// Currency + Stripe Price ID resolution for the 5 supported currencies.
// One source of truth for "which currency does this language pay in" and
// "which Stripe Price ID matches (plan, period, currency)".

export type Currency = 'DKK' | 'USD' | 'EUR' | 'PLN' | 'SEK'
export type PlanSlug = 'starter' | 'author' | 'pro'
export type BillingPeriod = 'monthly' | 'yearly'

export function currencyForLanguage(lang: string): Currency {
  const code = String(lang || '').toUpperCase()
  if (code === 'DA') return 'DKK'
  if (code === 'EN') return 'USD'
  if (code === 'SE' || code === 'SV') return 'SEK'
  if (code === 'PL') return 'PLN'
  if (['DE', 'ES', 'FR', 'IT', 'NL', 'PT'].includes(code)) return 'EUR'
  return 'USD' // fallback
}

// Cache Price ID lookups in memory for the session (no runtime Stripe calls).
const priceIdCache = new Map<string, string | undefined>()

/** Resolve the Stripe Price ID for a (plan, period, currency) combination. */
export function getPriceId(
  plan: PlanSlug,
  period: BillingPeriod,
  currency: Currency,
): string | undefined {
  const key = `VITE_STRIPE_${plan.toUpperCase()}_${period.toUpperCase()}_${currency}`
  if (priceIdCache.has(key)) return priceIdCache.get(key)
  const value = (import.meta.env as Record<string, string | undefined>)[key]
  priceIdCache.set(key, value)
  return value
}
